import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";
import { motion } from "framer-motion";
import { T } from "@/constants/testIds";

const items = [
  {
    q: "O que é este ebook?",
    a: "Um material digital de caráter informativo e histórico que reúne acontecimentos, investigações, controvérsias e decisões judiciais relacionadas aos temas abordados.",
  },
  {
    q: "Qual é o formato?",
    a: "Ebook digital em PDF.",
  },
  {
    q: "Quanto custa?",
    a: "R$ 19,99.",
  },
  {
    q: "Como faço a compra?",
    a: "Clique no ebook ou em qualquer botão de compra para ser direcionado ao gateway de pagamento Stripe.",
  },
  {
    q: "O material possui fontes?",
    a: "Sim. O projeto apresenta referências e fontes pertinentes aos acontecimentos abordados — STF, Polícia Federal, MP, Congresso e arquivos jornalísticos.",
  },
  {
    q: "O site é oficial do Exército Brasileiro ou da 11ª Região Militar?",
    a: "Não. Trata-se de uma publicação independente e sem vínculo oficial com instituições militares ou governamentais.",
  },
];

export default function FAQ() {
  return (
    <section id="faq" className="relative bg-[#070707] py-24 md:py-36 border-t border-white/5">
      <div className="mx-auto max-w-[1200px] px-5 md:px-10 grid grid-cols-1 lg:grid-cols-12 gap-14">
        <div className="lg:col-span-4">
          <div className="flex items-center gap-3 mb-5">
            <span className="h-[1px] w-10 bg-red-600" />
            <span className="eyebrow">Perguntas frequentes</span>
          </div>
          <h2 className="font-display font-black leading-[0.95] tracking-[-0.02em] text-4xl md:text-6xl text-neutral-50">
            Dúvidas <span className="text-red-600 italic">recorrentes</span>.
          </h2>
          <p className="mt-6 text-neutral-500 text-sm leading-relaxed">
            Não encontrou o que buscava? Escreva para contato@dossiebrasil.com.
          </p>
        </div>
        <div className="lg:col-span-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
          >
            <Accordion type="single" collapsible data-testid={T.faq} className="w-full">
              {items.map((it, i) => (
                <AccordionItem
                  key={it.q}
                  value={`item-${i}`}
                  className="border-b border-white/10"
                >
                  <AccordionTrigger className="font-display text-xl md:text-2xl text-neutral-50 py-6 hover:no-underline hover:text-red-500 text-left">
                    <span className="flex items-center gap-5">
                      <span className="font-mono text-[11px] text-red-500 tracking-[0.3em]">
                        0{i + 1}
                      </span>
                      {it.q}
                    </span>
                  </AccordionTrigger>
                  <AccordionContent className="text-neutral-400 text-[15px] leading-relaxed pb-6 pl-10">
                    {it.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
